import { render, staticRenderFns } from "./KETKanban.vue?vue&type=template&id=baf02b1a&"
import script from "./KETKanban.vue?vue&type=script&lang=js&"
export * from "./KETKanban.vue?vue&type=script&lang=js&"
import style0 from "./KETKanban.vue?vue&type=style&index=0&id=baf02b1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports